module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img3.06c1251a4dca7f58e36110e73ac6cdcd.jpg";